import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";
import {PREDICTION_WIDGET} from "../../prediction-widget/predictions-widget.consts";

export class PropositionBetsWidgetMarketShowMoreClickEvent extends ClickEvent {
  gameId: Number;
  status: Number;
  source: String;
  competitorId: Number;
  sportTypeId: Number;
  marketType: String;
  clickType: String;

  constructor(params) {
    super('', 'market_show-more-click', 'props');

    this.gameId = params.gameId;
    this.status = params.status;
    this.source = params.source;
    this.competitorId = params.competitorId;
    this.sportTypeId = params.sportTypeId;
    this.marketType = params.marketType;
    this.clickType = params.clickType;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.source = this.source;
    properties.competitorId = this.competitorId;
    properties.sportTypeId = this.sportTypeId;
    properties.marketType = this.marketType;
    properties.clickType = this.clickType;
    properties.subSource = PREDICTION_WIDGET.TABS_LABEL.props;

    return properties;
  }
}